import React, { Component } from 'react';

import { LinkIcon } from 'lucide-react';
import PropTypes from 'prop-types';

import { ViewerContext } from 'common/containers/ViewerContainer';
import JobsHomeHelmet from 'common/helmets/JobsHomeHelmet';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';

import ContentContainer from '../containers/ContentContainer';
import Button from '../inputs/Button';
import Link from '../Link';

import 'css/components/jobs/_JobsHome.scss';

import Team from 'img/team.jpg';

class JobsHome extends Component {
  static propTypes = {
    jobs: PropTypes.array,
    viewer: PropTypes.object,
  };

  renderCreateButton() {
    const { viewer } = this.props;
    if (!viewer || !viewer.cannyBae) {
      return null;
    }

    return (
      <Link to="/create">
        <Button value="Create Job" />
      </Link>
    );
  }

  renderJobs() {
    const { jobs } = this.props;
    const departmentJobs = {};
    jobs.forEach((job) => {
      const departmentURL = job.department.toLowerCase().replace(/\s/g, '-');
      const jobLink = '/' + departmentURL + '/' + job.urlName;
      departmentJobs[job.department] = departmentJobs[job.department] || [];
      departmentJobs[job.department].push(
        <Link className="departmentJob" to={jobLink} key={job._id}>
          {job.name}
        </Link>,
      );
    });

    const items = Object.keys(departmentJobs).map((department) => {
      return (
        <div className="departmentJobs" key={department}>
          <div className="departmentName">{department}</div>
          {departmentJobs[department]}
        </div>
      );
    });

    if (items.length === 0) {
      items.push(
        <p className="noOpenings" key="noOpenings">
          We don't have any openings right now, but we are always open to meeting exceptional
          candidates! If you think that's you, send your resume to{' '}
          <a href="mailto:jobs@canny.io?subject=Exceptional Candidate">jobs@canny.io</a>
        </p>,
      );
    }

    return (
      <div className="jobs">
        <div className="topContainer">
          <div className="heading">Openings</div>
          {this.renderCreateButton()}
        </div>
        {items}
      </div>
    );
  }

  render() {
    return (
      <ContentContainer outerClassName="jobsHome">
        <JobsHomeHelmet />
        <div className="headingContainer">
          <div className="title">Join our team</div>
          <div className="subtitle">
            We're looking for talented folks to help us improve the way people
            experience&nbsp;software.
          </div>
        </div>
        <LazyLoadedImage alt="Canny team" className="teamImage" src={Team} />
        <div className="blurb">
          <p>
            We help companies use feedback to build better products. With over 1,000 companies using
            Canny (including ClickUp, Mercury, and Missive) for feedback-driven product management,
            we’ve found a great product-market&nbsp;fit.
          </p>
          <p>
            Since Andrew (Engineering) and Sarah (Product) launched Canny in 2017, we’ve been
            bootstrapped, profitable, and remote only. Our team is growing in a very intentional and
            sustainable way. We’ve grown in all functions — sales, product, marketing, engineering,
            and&nbsp;operations.
          </p>
          <a href="https://canny.io/blog/work-at-canny/" className="blogPostLink">
            <LinkIcon strokeWidth={2} size={18} className="icon" />
            Read more about why Canny is a great place to&nbsp;work
          </a>
          <p>If you jive with that, check out our openings&nbsp;below!</p>
        </div>
        {this.renderJobs()}
      </ContentContainer>
    );
  }
}

export default withContexts({ viewer: ViewerContext })(JobsHome);
